import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { get } from 'lodash';

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.background.lightGray,
    ...theme.shape.componentSpacing,
  },
  header: {
    background: props =>
      get(props, 'fields.backgroundColor.fields.colorCode.value') ||
      theme.palette.background.default,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    ...theme.mixins.paddingLeft(theme.spacing(4)),
    [theme.breakpoints.up('lg')]: {
      height: theme.spacing(42.5),
      paddingTop: theme.spacing(6.5),
      paddingBottom: theme.spacing(0),
      ...theme.mixins.paddingLeft(theme.spacing(15.13)),
    },
  },
  content: {
    background: theme.mixins.White(),
    padding: `${pxToRem(32)} ${pxToRem(30)}`,
    color: theme.palette.text.darkGrey,
    [theme.breakpoints.up('lg')]: {
      marginTop: `-${theme.spacing(19.5)}`,
      padding: `${pxToRem(80)} ${pxToRem(120)}`,
    },
    '& h1,h2,h3,h4,h5': {
      paddingTop: theme.spacing(4),
      fontFamily: theme.custom.fontFamily.primaryBold,
      color: theme.palette.text.primary,
    },
    '& h4,h5': {
      paddingTop: theme.spacing(2),
      color: theme.palette.text.primary,
    },
    '& a': {
      color: theme.mixins.AbuDhabiOrange(),
    },
  },
}));

export default useStyles;
